var map = {
	"./agis-pc.png": "af8e",
	"./blue-marine-1.png": "e4fe",
	"./computer-3716291_1920.jpg": "f217",
	"./cpu-4393376_1920.jpg": "ef6c",
	"./dreammachine-pc.png": "5906",
	"./electronic-devices-514180_1920.jpg": "f942",
	"./equipo-gaming-elite-avanzado-procesador.jpg": "f0fe",
	"./gladius-pc.png": "1a75",
	"./le-blanc.png": "b18a",
	"./motherboard-232515_1920.jpg": "e288",
	"./nuc8-i3cysm-i3cysn-front-angle-rwd.png.rendition.intel.web.480.270.png": "5628",
	"./pc-escritorio.png": "dc98",
	"./processor-3720053_1920.jpg": "b414",
	"./shopping-cart.svg": "df25",
	"./telios-pc.png": "e195",
	"./thanos-pc.png": "b572"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8f6f";